export const capitalise = (string = '') =>
  string.charAt(0).toUpperCase() + string.slice(1);
